export default function TasksNotificationsRenderer() {
  this.renderLabel = (count) => {
    let text = "Tasks";
    if (count) {
      text += `<span class="badge badge-secondary ml-2">${count}</span>`;
    }

    $("a#tasks-nav-link").html(text);
  };
}
